import React from 'react'
import { Navigate } from 'react-router-dom'

import { useAuthContext } from 'contexts/AppAuthContext'

const RequireAuth = (props: { children: React.ReactNode }) => {
  const { children } = props

  const {
    authData: { web3token },
  } = useAuthContext()

  if (!web3token) {
    return <Navigate to="../login" />
  }

  return <>{children}</>
}

export default RequireAuth
